export default {
  tooltip: {
    backgroundColor: "#172D6D",
    borderColor: "#2B97FC",
    borderWidth: 0.5,
    textStyle: {
      color: "#fff"
    }
  },
  textStyle: {
    color: "#fff"
  }
}